import { useAuth0 } from '@auth0/auth0-react'
import * as Sentry from '@sentry/react'
import React, { useEffect } from 'react'
import { useFamilyMemberId } from '../hooks/useFamilyMemberId'

/**
 * Syncs the current user to Sentry so events (errors, transactions, replays) are attributed
 * consistently. Keyed by familyMemberId — stable across a person's email- and sms-primary
 * Auth0 accounts — rather than Auth0 email, which is absent entirely on an sms-primary session
 * (an sms|... account has no email attribute in Auth0). Falls back to email when
 * familyMemberId isn't available yet. Clears user context when logged out.
 */
const SentryUserSync: React.FC = () => {
  const { user } = useAuth0()
  const familyMemberId = useFamilyMemberId()

  useEffect(() => {
    if (familyMemberId) {
      Sentry.setUser({ id: familyMemberId, email: user?.email })
    } else if (user?.email) {
      Sentry.setUser({ email: user.email })
    } else {
      Sentry.setUser(null)
    }
  }, [familyMemberId, user?.email])

  return null
}

export default SentryUserSync
